<template>
  <div class="p-safe px-32">
    <slot />
  </div>
</template>
